<template>
  <b-row>
    <b-col>
      OAuth2 Connection Success
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'square-payments-oauth2-connect-success',
  computed: {
    isConnected: function() {
      return this.$store.getters['square/isConnected']
    }
  },
  created: function() {
    this.$store.dispatch('square/getIsConnected')
  }
}
</script>

<style lang="scss" scoped>

</style>
